import { TradeList } from "../../../data/domestic/trades/types";
import React from "react";
import { LocalizationContext } from "../../../core/localization/Localization";
import { Column } from "material-table";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

export const useTradeColumns = () => {
	const { getString, getDateTimeString, getFormatedNumberString, getDateString } = React.useContext(LocalizationContext);

	const theme = useTheme();
	const screenExtraSmall = useMediaQuery(theme.breakpoints.only('xs'));

	return React.useMemo(
		() => [
			{
				title: getString("tradeNo"),
				field: "clTranId",
				sorting: false,
				width: "160px",
				cellStyle: {
					maxWidth: "160px",
				},
				headerStyle: {
					maxWidth: "160px",
				},
				hidden: screenExtraSmall,
			},
			{
				title: getString("tradeTime"),
				render: trade => getDateTimeString(trade.tranTime),
				sorting: false,
				width: "180px",
				cellStyle: {
					maxWidth: "180px",
					minWidth: "180px",
					width: "180px",
				},
				headerStyle: {
					maxWidth: "180px",
					minWidth: "180px",
					width: "180px",
				},
				hidden: screenExtraSmall,
			},
			{
				title: getString("tradeTime"),
				render: trade => getDateString(trade.tranTime),
				sorting: false,
				width: "100px",
				cellStyle: {
					maxWidth: "100px",
					minWidth: "100px",
					width: "100px",
				},
				headerStyle: {
					maxWidth: "100px",
					minWidth: "100px",
					width: "100px",
				},
				hidden: !screenExtraSmall,
			},
			{
				title: getString("tradeSecurity"),
				field: "symbol",
				sorting: false,
			},
			{
				title: getString("tradeIsin"),
				field: "isin",
				sorting: false,
				hidden: screenExtraSmall,
			},
			{
				title: getString("tradeExchange"),
				field: "exchCode",
				sorting: false,
				hidden: screenExtraSmall,
			},
			{
				title: getString("tradeDescr"),
				field: "tranDesc",
				sorting: false,
			},
			{
				title: getString("tradeQty"),
				render: trade => getFormatedNumberString(trade.qty) ,
				sorting: false,
				cellStyle: {
					minWidth: "130px",
					whiteSpace: "nowrap",
					textAlign: "end",
				},
				headerStyle: {
					minWidth: "130px",
					textAlign: "end",
				},
				hidden: screenExtraSmall,
			},
			{
				title: getString("orderPrice"),
				render: trade => getFormatedNumberString(trade.price, true),
				sorting: false,
				cellStyle: {
					whiteSpace: "nowrap",
					textAlign: "end",
				},
				headerStyle: {
					whiteSpace: "nowrap",
					textAlign: "end",
				},
				hidden: screenExtraSmall,
			},
			{
				title: getString("tradeCurrCode"),
				field: "curr",
				sorting: false,
				hidden: screenExtraSmall,
			},
			{
				title: getString("tradeAmt"),
				render: trade => getFormatedNumberString(trade.tradeAmt, true) ,
				sorting: false,
				cellStyle: {
					minWidth: "130px",
					whiteSpace: "nowrap",
					textAlign: "end",
				},
				headerStyle: {
					minWidth: "130px",
					textAlign: "end",
				},
				hidden: screenExtraSmall,
			},
			{
				title: getString("tradeComm"),
				render: trade => getFormatedNumberString(trade.feesAmt, true) ,
				sorting: false,
				cellStyle: {
					minWidth: "130px",
					whiteSpace: "nowrap",
					textAlign: "end",
				},
				headerStyle: {
					minWidth: "130px",
					textAlign: "end",
				},
				hidden: screenExtraSmall,
			},
			{
				title: getString("tradeOrder"),
				field: "ordNo",
				sorting: false,
				hidden: screenExtraSmall,
			},
		],
		[getString, getDateTimeString, getFormatedNumberString, screenExtraSmall]
	) as Column<TradeList>[];
};
